import React from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import {SubmitError} from "../../types";

interface SnackbarAlertProps {
    open: boolean;
    error: string;
    translate: (key: string) => string;
    handleClose: () => void;
}

const SnackbarAlert: React.FC<SnackbarAlertProps> = ({open, error, translate, handleClose}) => {
    function renderHeadline(error: string) {
        switch (error) {
            case "UNKNOWN":
            case SubmitError.UNKNOWN:
                return translate("errors.headline_technical");
            case SubmitError.TWICE_SUBMITTED:
                return translate("errors.headline_twice");
            default:
                return translate("errors.headline_generic");
        }
    }

    return (
        <Snackbar
            anchorOrigin={{vertical: "bottom", horizontal: "center"}}
            open={open}
            style={{display: "flex", justifyContent: "center", width: "100%"}}
        >
            <Alert
                icon={false}
                sx={{
                    backgroundColor: "primary.main",
                    color: "white",
                    marginLeft: {
                        xs: "8px",
                        sm: "24px",
                        md: "0",
                    },
                    marginRight: {
                        xs: "24px",
                        md: "0",
                    },
                    padding: "32px 24px",
                    boxSizing: "border-box",
                    width: {
                        xs: "100%",
                        md: "779px",
                    },
                    position: "relative",
                    boxShadow: "0px 4px 4px 0px #00000040",
                    borderRadius: 0,
                    ">div": {
                        padding: 0,
                        maxWidth: "100%",
                    }
                }}
                action={
                    <Button
                        onClick={handleClose}
                        sx={{
                            position: "absolute",
                            color: "primary.contrastText",
                            top: "12px",
                            right: "12px",
                            padding: "4px",
                            minWidth: "14px",
                        }}
                    >
                        <CloseIcon/>
                    </Button>
                }
            >
                <Typography variant="h3" component="h1" sx={{paddingTop: 0, marginBottom: "8px"}}>
                    {renderHeadline(error)}
                </Typography>
                <Typography sx={{paddingBottom: 0}}>{translate(`errors.${error}`)}</Typography>
            </Alert>
        </Snackbar>
    );
};

export default SnackbarAlert;
